export const TOGGLE_OWNERSHIP_SECTION = 'TOGGLE_OWNERSHIP_SECTION'

export const TYPES = { CHILDS: 'childs', PARENTS: 'parents' }
